import create from 'zustand'
import { CataractType } from '../../types/graphql'

type CataractTypeFormValues = {
  data: CataractType
  isEditing: boolean
}

type CataractTypeFormActions = {
  setData: (data: CataractType) => void
  reset: () => void
  setIsEditing: (isEditing: boolean) => void
}

export type CataractTypeFormState = CataractTypeFormValues &
  CataractTypeFormActions

const initialState: CataractTypeFormValues = {
  isEditing: false,
  data: {
    position: 0,
    id: '',
    internalAnnotations: '',
    name: '',
    simulations: [],
    cacheKey: '',
    slug: '',
    thumb: '',
    timestamp: {},
    enable: true
  }
}

export const useCataractTypeForm = create<CataractTypeFormState>(set => ({
  ...initialState,
  setData: data => set(state => ({ ...state, data })),
  reset: () => set({ ...initialState }),
  setIsEditing: isEditing => set(state => ({ ...state, isEditing }))
}))
